define('SuiteCommerce.OrderStatus.Configuration', [], function Configuration() {
  'use strict';
  return {
    environment: null,
    initialize: function initialize(container) {
      this.environment = container.getComponent('Environment');
    },
    get: function get(name) {
      if (this.environment) {
        return this.environment.getConfig(name);
      }
      return null;
    },
    getSiteSetting: function getSiteSetting(name){
      if (this.environment) {
        return this.environment.getSiteSetting(name);
      }
      return null;
    }
  };
});
